import { Component } from '@angular/core';

@Component({
  selector: 'app-form-radio-demo',
  templateUrl: './form-radio-demo.component.html',
})
export class FormRadioDemoComponent {}
